import { Component, Input } from '@angular/core';

import { EndorsementBase } from '../../models';

@Component({
    selector: 'app-system-endorsement',
    templateUrl: './system-endorsement.component.html',
    styleUrls: ['./system-endorsement.component.scss'],
    standalone: false
})
export class SystemEndorsementComponent extends EndorsementBase {

  @Input() altText: string;
}
